import { Record } from "appworks/model/gameplay/records/record";
import { Services } from "appworks/services/services";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { ygg } from "ygg/ygg";

export function TGRShouldCelebrateWins(record: Record): boolean {
    const license: string = PartnerConnectManager.getConfig().customParameters?.license?.toLowerCase();
    const isPrepaid: boolean = PartnerConnectManager.getGame().getWagerHelper()?.getPrepaidInfo()?.isPrepaid;
    if (!isPrepaid && ygg.licensesSubstakeCelebrationsDisabled.indexOf(license) > -1) {
        if (record.cashWon <= Services.bet.getTotalStake()) {
            return false;
        }
    }
    return true;
}
